var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLocalhost)?_c('div',{staticClass:"turnstile-wrapper"},[_c('div',{ref:"turnstileContainer"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }